<template>
    <div class="achievement-modal">
        <div class="icon">
            <img :src="badgeData.badgeIcon"
                width="100%"
            >
            <level-number v-if="isLevelup"
                :level="badgeData.levelNo"
                class="level-number"
            />
        </div>

        <div v-if="isBadgeInfo && badgeData.showProgressBar"
            class="progress-bar-container"
        >
            <progress-bar :percentage="Number(badgeData.progressPercentage)"
                :longText="false"
                :customHeight="0.6"
                :dark="true"
            />
        </div>

        <h1 v-if="computedMainTitle"
            class="title title--main"
        >
            {{ computedMainTitle }}
        </h1>
        <h2 v-if="computedBadgeTitle"
            class="title title--secondary"
        >
            {{ computedBadgeTitle }}
        </h2>
        <p class="description">{{ badgeData.badgeDesc }}</p>
        <p v-if="formattedDate"
            class="completed-date"
        >
            {{ $t('badgeAchievementSheet.badgeEarnedDate', {date: formattedDate}) }}
        </p>

        <div v-if="hasReward"
            class="xp-reward"
        >
            <div>{{ $t('badgeAchievementSheet.rewardTitle') }}</div>
            <xp-badge v-if="badgeData.rewardCurrency === 'xp'"
                :fontSize="3"
                :padding="2"
            />
            <token-badge v-if="badgeData.rewardCurrency === 'coin'"
                :partnerShortName="'SSU'"
            />
            <div class="xp-reward__amount">{{ badgeData.rewardAmount }}</div>
        </div>
    </div>
</template>
<script>
// 3rd party libs
import {
    mapGetters,
} from 'vuex';

// Utils
import {
    format,
} from '@shared/utils/dates';

// Components
import xpBadge from '@webapp/modules/rewards/components/badges/xp-badge.vue';
import levelNumber from '@webapp/modules/rewards/components/level-number.vue';
import tokenBadge from '@webapp/modules/rewards/components/badges/token-badge.vue';
import progressBar from '@webapp/components/progress/progress-bar.vue';

export default {
    name: 'insertcoin-achievement-sheet',
    components: {
        xpBadge,
        levelNumber,
        tokenBadge,
        progressBar,
    },
    data() {
        return {
            badgeData: {
                type: 'achievement',
                mainTitle: this.$t('badgeAchievementSheet.title'),
                badgeTitle: '',
                badgeDesc: '',
                badgeIcon: '',
                rewardAmount: 0,
                rewardCurrency: 'xp',
            },
        };
    },
    computed: {
        ...mapGetters(['modal']),

        isLevelup() {
            return this.badgeData.type === 'levelup';
        },

        isBadgeInfo() {
            return this.badgeData.type === 'badgeInfo';
        },

        levelUpData() {
            return {
                badgeIcon: require('@webapp/modules/rewards/assets/images/levelup-bg.webp'),
                mainTitle: this.$t('badgeAchievementSheet.levelUpTitle'),
                badgeTitle: this.$t('badgeAchievementSheet.levelUpBadgeTitle'),
                badgeDesc: this.$t('badgeAchievementSheet.levelUpBadgeDesc'),
            };
        },

        hasReward() {
            return ['xp', 'coin'].includes(this.badgeData.rewardCurrency);
        },

        computedMainTitle() {
            if (this.formattedDate) {
                return this.badgeData.mainTitle;
            }

            return this.badgeData.badgeTitle;
        },

        computedBadgeTitle() {
            if (this.formattedDate) {
                return this.badgeData.badgeTitle;
            }

            return '';
        },

        formattedDate() {
            return this.badgeData.completedAt ? format(this.badgeData.completedAt, 'dateMonthLong') : '';
        },
    },
    watch: {
        'modal.data': {
            immediate: true,
            handler(modalData) {
                if (modalData) {
                    this.badgeData = {
                        ...this.badgeData,
                        ...modalData,
                    };

                    if (modalData.type === 'levelup') {
                        this.badgeData = {
                            ...this.badgeData,
                            ...this.levelUpData,
                        };
                    }
                }
            },
        },
    },
};
</script>
<style lang="scss" scoped>
.achievement-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: $daintree-color;
    width: 85%;
    z-index: 1;

    .icon {
        width: 15rem;
        position: relative;
    }

    .progress-bar-container {
        margin: 0 0 2rem;
        width: 20%;
    }

    .title {
        font-weight: bold;

        &--main {
            font-size: 2rem;
        }

        &--secondary {
            font-size: 1.5rem;
        }
    }

    .description {
        font-size: 1.4rem;
        margin-bottom: 0;
    }

    .completed-date {
        font-size: 1.2rem;
        font-weight: bold;
    }

    .xp-reward {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: bold;
        font-size: 1.3rem;
        margin: 4rem 0 0;

        > div {
            padding: 0.4rem 0;
        }

        &__amount {
            font-size: 1.8rem;
        }
    }

    .level-number {
        position: absolute;
        width: 7.5rem;
        height: 5rem;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -75%);
    }
}
</style>